var Panasonic_theater_system = {
    name: "theater_system",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [99,0,4,33,2,47,1,34,2,181,4,231,13,105,6,19,2,0,0,55,255,191,219,171,218,174,254,136],
        },
        {
            function: "SLEEP",
            name: "SLEEP",
            icon: "SLEEP",
            command: [99,0,4,33,2,40,1,46,2,174,4,226,13,107,6,38,2,0,0,55,255,191,219,171,235,118,219,136],
        },
        {
            function: "TV: POWER (DOUBLE)",
            name: "TV: POWER (DOUBLE)",
            icon: "TV: POWER (DOUBLE)",
            command: [99,0,4,44,2,35,1,39,2,174,4,253,13,90,6,38,2,0,0,55,255,191,247,253,170,237,86,136],
        },
        {
            function: "TV: VOL UP",
            name: "TV: VOL UP",
            icon: "TV: VOL UP",
            command: [99,0,4,40,2,37,1,60,2,174,4,252,13,76,6,25,2,0,0,55,255,191,247,255,239,246,136],
        },
        {
            function: "TV: VOL DOWN",
            name: "TV: VOL DOWN",
            icon: "TV: VOL DOWN",
            command: [99,0,4,41,2,36,1,51,2,177,4,237,13,97,6,31,2,0,0,55,255,191,247,253,247,125,162],
        },
        {
            // function: "TV: AV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [99,0,4,40,2,36,1,53,2,173,4,3,14,88,6,49,2,0,0,55,255,191,247,253,191,111,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [99,0,4,36,2,38,1,43,2,174,4,228,13,107,6,35,2,0,0,55,255,191,219,171,253,250,218,32],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [99,0,4,37,2,36,1,45,2,170,4,227,13,114,6,37,2,0,0,55,255,191,219,171,222,246,182,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [99,0,4,39,2,37,1,46,2,171,4,226,13,110,6,21,2,0,0,55,255,191,219,171,238,250,182,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [99,0,4,40,2,40,1,40,2,167,4,234,13,99,6,49,2,0,0,55,255,191,219,171,215,122,173,162],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [99,0,4,35,2,40,1,49,2,168,4,227,13,102,6,18,2,0,0,55,255,191,219,171,246,254,218,32],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [99,0,4,40,2,33,1,54,2,166,4,230,13,105,6,32,2,0,0,55,255,191,219,171,219,123,182,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [99,0,4,38,2,34,1,52,2,171,4,232,13,109,6,31,2,0,0,55,255,191,219,171,235,125,182,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [99,0,4,38,2,37,1,43,2,171,4,235,13,105,6,27,2,0,0,55,255,191,219,171,213,189,109,162],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [99,0,4,37,2,36,1,50,2,171,4,5,14,111,6,25,2,0,0,55,255,191,219,171,250,253,218,32],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [99,0,4,36,2,37,1,43,2,175,4,228,13,115,6,22,2,0,0,55,255,191,219,171,221,123,118,136],
        },
        {
            function: "KEY_CANCEL",
            name: "KEY_CANCEL",
            icon: "KEY_CANCEL",
            command: [99,0,4,38,2,35,1,56,2,178,4,223,13,116,6,63,2,0,0,55,255,191,219,123,255,111,226],
        },
        {
            function: "KEY_10",
            name: "KEY_10",
            icon: "KEY_10",
            command: [99,0,4,37,2,36,1,43,2,173,4,224,13,107,6,55,2,0,0,55,255,191,219,171,247,222,174,32],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [99,0,4,41,2,35,1,50,2,178,4,233,13,110,6,26,2,0,0,55,255,191,219,255,247,254,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [99,0,4,40,2,34,1,52,2,174,4,229,13,102,6,37,2,0,0,55,255,191,219,254,251,191,162],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [99,0,4,37,2,37,1,42,2,175,4,249,13,104,6,28,2,0,0,55,255,191,219,255,117,238,232,128],
        },
        {
            function: "KEY_DVD",
            name: "KEY_DVD",
            icon: "KEY_DVD",
            command: [99,0,4,38,2,36,1,43,2,177,4,226,13,101,6,50,2,0,0,55,255,191,219,254,189,171,248,128],
        },
        {
            function: "IPOD",
            name: "IPOD",
            icon: "IPOD",
            command: [99,0,4,37,2,41,1,38,2,176,4,224,13,105,6,38,2,0,0,55,255,191,219,254,181,213,171,136],
        },
        {
            function: "EXT-IN",
            name: "EXT-IN",
            icon: "EXT-IN",
            command: [99,0,4,35,2,43,1,49,2,180,4,229,13,106,6,55,2,0,0,55,255,191,219,191,221,191,226],
        },
        {
            function: "FAST BACKWARD (SEARCH)",
            name: "FAST BACKWARD (SEARCH)",
            icon: "FAST BACKWARD (SEARCH)",
            command: [99,0,4,34,2,43,1,39,2,181,4,229,13,115,6,12,2,0,0,55,255,191,219,123,223,255,162],
        },
        {
            function: "PLAY",
            name: "PLAY",
            icon: "PLAY",
            command: [99,0,4,27,2,51,1,40,2,184,4,229,13,124,6,23,2,0,0,55,255,191,219,123,219,253,232,128],
        },
        {
            function: "FAST FORWARD (SEARCH)",
            name: "FAST FORWARD (SEARCH)",
            icon: "FAST FORWARD (SEARCH)",
            command: [99,0,4,29,2,50,1,38,2,183,4,227,13,128,6,25,2,0,0,55,255,191,219,123,175,239,232,128],
        },
        {
            function: "PREVIOUS (SKIP)",
            name: "PREVIOUS (SKIP)",
            icon: "PREVIOUS (SKIP)",
            command: [99,0,4,30,2,51,1,32,2,180,4,229,13,113,6,26,2,0,0,55,255,191,219,171,221,219,106,162],
        },
        {
            function: "PAUSE",
            name: "PAUSE",
            icon: "PAUSE",
            command: [99,0,4,29,2,50,1,41,2,182,4,228,13,114,6,24,2,0,0,55,255,191,219,123,215,251,232,128],
        },
        {
            function: "NEXT (SKIP)",
            name: "NEXT (SKIP)",
            icon: "NEXT (SKIP)",
            command: [99,0,4,30,2,50,1,31,2,178,4,233,13,112,6,26,2,0,0,55,255,191,219,171,237,221,106,162],
        },
        {
            function: "STOP",
            name: "STOP",
            icon: "STOP",
            command: [99,0,4,30,2,52,1,45,2,184,4,2,14,111,6,10,2,0,0,55,255,191,219,123,255,223,162],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [99,0,4,30,2,48,1,38,2,180,4,232,13,116,6,43,2,0,0,55,255,191,219,123,254,183,216,128],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [99,0,4,29,2,46,1,35,2,180,4,221,13,117,6,43,2,0,0,55,255,191,219,171,237,171,91,98],
        },
        {
            function: "TOP MENU",
            name: "TOP MENU",
            icon: "TOP MENU",
            command: [99,0,4,27,2,50,1,37,2,182,4,232,13,113,6,41,2,0,0,55,255,191,219,123,173,181,219,136],
        },
        {
            function: "START",
            name: "START",
            icon: "START",
            command: [99,0,4,29,2,50,1,28,2,180,4,229,13,111,6,41,2,0,0,55,255,191,219,171,214,218,173,226],
        },
        {
            function: "FUNCTIONS",
            name: "FUNCTIONS",
            icon: "FUNCTIONS",
            command: [99,0,4,24,2,53,1,36,2,181,4,234,13,118,6,11,2,0,0,55,255,191,219,123,171,109,182,162],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [99,0,4,31,2,52,1,35,2,177,4,228,13,105,6,28,2,0,0,55,255,191,219,123,237,122,214,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [99,0,4,30,2,50,1,35,2,175,4,227,13,120,6,29,2,0,0,55,255,191,219,123,171,93,181,162],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [99,0,4,29,2,49,1,37,2,177,4,227,13,101,6,21,2,0,0,55,255,191,219,123,182,186,181,162],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [99,0,4,28,2,46,1,38,2,181,4,248,13,115,6,21,2,0,0,55,255,191,219,123,214,190,214,136],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [99,0,4,30,2,48,1,39,2,179,4,230,13,117,6,41,2,0,0,55,255,191,219,123,215,174,246,32],
        },
        {
            function: "PLAY MODE",
            name: "PLAY MODE",
            icon: "PLAY MODE",
            command: [99,0,4,35,2,41,1,33,2,178,4,233,13,112,6,40,2,0,0,55,255,191,219,123,173,90,234,226],
        },
        {
            function: "RETURN",
            name: "RETURN",
            icon: "RETURN",
            command: [99,0,4,30,2,48,1,38,2,178,4,227,13,109,6,43,2,0,0,55,255,191,219,123,239,90,246,32],
        },
        {
            function: "SOUND",
            name: "SOUND",
            icon: "SOUND",
            command: [99,0,4,32,2,47,1,35,2,180,4,224,13,116,6,49,2,0,0,55,255,191,219,239,95,171,174,32],
        },
        {
            function: "SURROUND",
            name: "SURROUND",
            icon: "SURROUND",
            command: [99,0,4,36,2,40,1,45,2,175,4,232,13,117,6,22,2,0,0,55,255,191,219,254,245,222,232,128],
        },
        {
            function: "MIC VOL",
            name: "MIC VOL",
            icon: "MIC VOL",
            command: [99,0,4,32,2,43,1,35,2,178,4,225,13,102,6,41,2,0,0,55,255,191,219,183,186,213,173,98],
        },
        {
            function: "ECHO",
            name: "ECHO",
            icon: "ECHO",
            command: [99,0,4,32,2,43,1,39,2,181,4,223,13,80,6,39,2,0,0,55,255,191,219,183,254,187,86,32],
        },
    ]
}
export default Panasonic_theater_system